<template>
  <div class="jy-container">
    <div class="jy-inner">
      <div class="jy-header">
        <img :src="'data:image/png;base64,'+item.user.headimgBase64">
      </div>
      <div class="jy-right">
        <div class="right-top">
          <div class="jy-name-time">
            <div class="jy-name">
              {{item.user.nickname}}
              <i class="iconfont icon-nan2" v-if="item.user.sex==1"></i>
              <i class="iconfont icon-nv2" v-else></i>
            </div>
            <div class="jy-time">{{createTime}}钟前发布</div>
          </div>
          <div class="zym">
            <span class="zym-flag">座右铭</span>
            {{item.user.motto}}
          </div>
        </div>
        <div class="word">
          <i class="iconfont icon-broadcast"></i>
          <span v-html="item.word"></span>
        </div>
        <div class="pics-container">
          <div class="pics" v-if="item.pics && item.pics.length > 0">
            <img
              class="pic"
              v-for="(pic, index) in item.pics"
              :key="'pic_'+index"
              :src="pic"
              :style="imgStyle(index)"
              @click="showImagePreview(index)"
            >
          </div>
        </div>
        <div class="item-footer">
          <div class="viewzan">
            <div class="item-footer-item" @click="zan">
              <i class="iconfont icon-dianzan"></i>
              <span>{{item.zan}}人</span>
            </div>
            <div class="item-footer-item" @click="cai">
              <i class="iconfont icon-diancai"></i>
              <span>{{item.cai}}人</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import weui from "weui.js";

export default {
  props: {
    item: Object,
    openid: String
  },
  data() {
    return {
      createTime: null,
      picWidth: 0,
      initialIndex: 0
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let du = moment.duration(moment() - moment(this.item.createdAt), "ms");
    this.createTime = du.locale("zh-cn").humanize();

    if (this.item.word) {
      this.item.word = this.item.word.replace(/\n/g, "<br/>");
    }
  },
  methods: {
    imgStyle(index) {
      if (index == 2 || index == 5 || index == 8) {
        let style =
          "width:" +
          this.picWidth +
          "px; height:" +
          this.picWidth +
          "px; margin-right: 0px;";
        return style;
      } else {
        let style =
          "width:" + this.picWidth + "px; height:" + this.picWidth + "px;";
        return style;
      }
    },
    showImagePreview(index) {
      this.initialIndex = index;
      const params = {
        $props: {
          imgs: this.item.pics,
          initialIndex: "initialIndex", // 响应式数据的key名
          loop: false
        },
        $events: {
          change: i => {
            // 必须更新 initialIndex
            this.initialIndex = i;
          }
        }
      };
      this.$createImagePreview({ ...params }).show();
    },
    zan() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 40,
          type: 20,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已赞过", 500);
          } else {
            this.item.zan++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cai() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 40,
          type: 30,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已踩过", 500);
          } else {
            this.item.cai++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.picWidth = parseInt((document.body.clientWidth - 112) / 3);
  }
};
</script>

<style scoped>
.icon-nan2 {
  color: #1296db;
}
.icon-nv2 {
  color: #ff9db3;
}
.jy-container {
  margin: 10px;
  border: 1px solid #fda800;
  border-radius: 10px;
}
.jy-inner {
  display: flex;
  margin: 10px;
}
.jy-header {
  margin-right: 10px;
}
.jy-header img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.jy-right {
  width: 100%;
}
.right-top {
  border-bottom: 1px solid #efefef;
}
.jy-name-time {
  display: flex;
}
.jy-name {
  flex: 1;
  font-size: 16px;
}
.zym {
  margin-bottom: 5px;
}
.zym-flag {
  background-color: #1296db;
  color: #ffffff;
  padding: 1px 4px;
}
.word {
  font-size: 15px;
  margin-top: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #efefef;
}
.icon-broadcast {
  color: red;
  font-weight: bold;
  margin-right: 5px;
}
.pics-container {
  border-bottom: 1px solid #efefef;
}
.pics {
  padding-bottom: 5px;
}
.pic-bottom {
  padding-bottom: 10px;
}
.pic {
  object-fit: cover;
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
}
.item-footer {
  display: flex;
  margin-top: 5px;
}
.viewzan {
  flex: 1;
  display: flex;
  align-items: center;
}
.item-footer-item span {
  font-size: 15px;
  margin-left: 2px;
}
.item-footer-item + .item-footer-item {
  margin-left: 5px;
}
</style>





// WEBPACK FOOTER //
// src/components/common/JiyuItem.vue